import { googlePlaceToAddress } from '@/components/utils/GooglePlacesAutocomplete/adapters';
import { GooglePlacesPayload } from '@/components/utils/GooglePlacesAutocomplete/types';
import { FCRAWorker } from '@/types/turn-api';

export const transformAddressDetails = (data: GooglePlacesPayload): FCRAWorker.Address => {
  const address = googlePlaceToAddress(data);
  const values: Partial<FCRAWorker.Address> = {};

  Object.keys(address).forEach((key) => {
    const value = address[key];
    if (value !== undefined && value !== null && value !== '') {
      values[key] = value;
    }
  });

  return values as FCRAWorker.Address;
};
